import React from 'react';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Enhanced loading overlay specifically for authentication flows in PWA
 * Provides better UX during sign-in redirects
 */
const AuthLoadingOverlay = ({ open, message }) => {
  const { t } = useTranslation('common');

  if (!open) return null;

  return (
    <Fade in={open}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(8px)',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          // PWA safe area support
          paddingTop: 'max(env(safe-area-inset-top), 20px)',
          paddingBottom: 'max(env(safe-area-inset-bottom), 20px)',
          paddingLeft: 'env(safe-area-inset-left)',
          paddingRight: 'env(safe-area-inset-right)',
        }}
      >
        <CircularProgress 
          size={60} 
          thickness={4}
          sx={{ 
            color: 'primary.main',
            mb: 3
          }} 
        />
        <Typography 
          variant="h6" 
          color="text.primary"
          textAlign="center"
          sx={{ 
            mb: 1,
            fontWeight: 500,
            px: 3
          }}
        >
          {message || t('authentication.signingIn')}
        </Typography>
        <Typography 
          variant="body2" 
          color="text.secondary"
          textAlign="center"
          sx={{ 
            px: 3,
            maxWidth: 300,
            lineHeight: 1.5
          }}
        >
          {t('authentication.pleaseWait')}
        </Typography>
      </Box>
    </Fade>
  );
};

export default AuthLoadingOverlay;
